/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// redux
import {
  useSelector,
  shallowEqual,
  // useDispatch
} from "react-redux";
// component
import PersonTreeTable from "../../../components/PersonTreeTable";
// utils
import { get, isEmpty, isNumber } from "lodash";
// import { sortByKey } from "../../../utils/sort";
import { setTreeDataByParts } from "../../../utils/treeData";
import { getContractsList } from "../../../apis/contract";
import { getPartsDetail } from "../../../apis/companies/parts";
import Contract from "../../../components/Contract/Contract";
import { preventEvent } from "../../../utils/element";
import { employeePreview } from "../../../utils/employee";
import emptyUserImage from "../../../assets/images/empty-user-img.png";


const AdminContract = () => {
  // const dispatch = useDispatch();
  const { user, parts, company, employees, companies } = useSelector(
    (store) => ({
      user: store.Profile.user,
      parts: store.Data.parts,
      company: store.Profile.company,
      employees: store.Data.employees,
      companies: store.Data.companies,
    }),
    shallowEqual
  );

  const [treeData, setTreeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState({
    name: "",
    employees: [],
  });
  // 직원 등록
  const [defaultSelected, setDefaultSelected] = useState(["company"]);
  const [selectedData, setSelectedData] = useState({});
  const [isFirst, setIsFirst] = useState(true);
  const [fields] = useState([
    {
      key: "name",
      width: "45%",
      onValue: (value, field, data) => {
        const { profileImg, partName, name } = data;
        return (
          <div className="user-wrap" style={{
            whiteSpace: 'nowrap'
          }}>
            <div className="profile-container" onClick={(e) => showPreviewEmployee(e, data)}>
              <div className="profile-img-wrap">
                <img src={profileImg || emptyUserImage} alt={data.name} />
              </div>
              <span className="name">{name}</span>
            </div>
            <span className="part">{partName}</span>
          </div>
        );
      },
    },
    {
      key: "contracts",
      width: "55%",
      onValue: (value, field, data) => {
        return (
          !isEmpty(value) ?
            value.map((contract, idx) => (
              <Contract key={idx} submit={submit} {...contract} />
            ))
            : <p className="empty-contract">등록된 계약서가 없습니다</p>
        );
      },
    },
  ]);

  useEffect(() => {
    submit();
    setIsFirst(true);
  }, [parts, companies, user, employees, company]);

  const submit = () => {
    setIsLoading(true);
    let treeData = [];

    // division
    if (!isEmpty(company) && !isEmpty(user)) {
      treeData = [
        {
          title: get(company, "name"),
          key: "company",
          children: [
            ...setTreeDataByParts(parts),
            { title: "미지정", key: "unspecified" },
          ],
        },
      ];
    }

    setIsLoading(false);
    if (!isEmpty(treeData) && !isEmpty(employees)) {
      setTreeData(treeData);
      if (isFirst) {
        setSelectedData(treeData[0]);
        setDefaultSelected(["company"]);
        _setTableData(get(treeData, "[0].title"), employees);
      }
      setIsFirst(false);
    }
  };

  const onSelect = (keys, nodeData) => {
    const { node, selected } = nodeData;
    if (selected) {
      setSelectedData(node);

      // 회사
      if (node.key === "company") {
        _setTableData(company.name, employees);
      } else if (node.key === "unspecified") {
        // 담당자
        const employeeList = employees.filter((employee) => !employee.partIdx);
        _setTableData(node.title, employeeList);
      } else {
        matchEmployeeInParts(node.idx);
      }
    } else {
      setSelectedData({});
      setTableData({});
    }
  };

  // 부서에 직원 매칭
  const matchEmployeeInParts = (idx) => {
    if (!isNumber(idx)) return;
    getPartsDetail(idx).then((res) => {
      const { partName, companyPartEmployees } = res.data.part;
      const reformEmployee = companyPartEmployees.map((e) => ({
        idx: e.employeeIdx,
        name: e.employee.name,
        type: e.type,
      }));
      _setTableData(partName, reformEmployee);
    });
  };

  const _setTableData = (name, employeeList) => {
    const targetEmployee = employeeList || employees;
    const targetEmployeeIdx = targetEmployee.map((e) => e.idx || e.employeeIdx);

    getContractsList({ targetEmployeeIdx }).then((res) => {
      const contracts = get(res, 'data.contract.contracts', []);
      setTableData({
        name,
        employees: targetEmployee.map((employee) => ({
          idx: get(employee, "idx"),
          name: get(employee, "name"),
          code: get(employees.find((e) => e.idx === get(employee, "idx")), 'code') || "",
          gradeName: get(employees.find((e) => e.idx === get(employee, "idx")), 'gradeName') || "",
          profileImg: get(employees.find(e => e.idx === get(employee, "idx")), 'profileImg') || "",
          partName: get(employees.find(e => e.idx === get(employee, "idx")), 'partName'),
          contracts: contracts.filter(contract => contract.targetEmployeeIdx === employee.idx) || []
        })),
      });
    });
  };

  const showPreviewEmployee = (e, _data) => {
    preventEvent(e);
    employeePreview(_data.idx);
  };

  return (
    <>
      <PersonTreeTable
        submit={submit}
        tableFields={fields}
        isLoading={isLoading}
        treeData={treeData}
        setTreeData={setTreeData}
        tableData={tableData}
        onSelect={onSelect}
        defaultSelectedKeys={defaultSelected}
        selectedData={selectedData}
      />
    </>
  );
};

export default AdminContract;
